import { render } from "./AssessorLink.vue?vue&type=template&id=6a591020"
import script from "./AssessorLink.vue?vue&type=script&lang=js"
export * from "./AssessorLink.vue?vue&type=script&lang=js"

import "./AssessorLink.vue?vue&type=style&index=0&id=6a591020&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__